<div class="prose">
  <h1 class="flex items-start gap-6">
    {{ headline }}
    @if (isLoading !== undefined) {
      <app-number class="flex" size="default" [type]="type">
        @if (isLoading) {
          <svg-icon
            class="block size-5 animate-spin"
            src="assets/icons/General/loading-01.svg"
          />
        } @else {
          {{ count }}
        }
      </app-number>
    }
  </h1>
</div>
